import { Box, Modal } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import ModalStyle from '@/constants/ModalStyle';
import ButtonCloseModal from '../../ui/Button/ButtonCloseModal';
import { format } from 'date-fns';

const Label = ({ label, value }) => {
	return (
		<div className='flex gap-1'>
			<strong>{label}</strong>
			{value}
		</div>
	);
};

export default function ProjectDetail(props) {
	const dispatch = useDispatch();
	const { open } = props;
	const showPublicDetail = useSelector((state) => state.trigger.showPublicDetail);
	const { name, type, number, date, article } = showPublicDetail;
	const onClose = () => {
		dispatch({
			type: 'trigger/triggerAPI',
			payload: {
				key: 'showPublicDetail',
				value: null,
			},
		});
	};
	return (
		<Modal open={open} onClose={onClose} aria-labelledby='modal-project-qr' aria-describedby='modal-project-qr' className='w-full'>
			<Box sx={{ ...ModalStyle, top: '25svh' }} className='relative flex flex-col gap-4 w-[90%] md:w-[680px] h-auto'>
				<span className='mb-2 text-2xl modal-title'>Detail</span>
				<ButtonCloseModal onClose={onClose} />

				<hr />
				<div className='flex flex-col justify-center gap-4'>
					<Label label='Dokumenttype' value={type} />
					<Label label='Nummer' value={number} />
					<Label label='Produktnavn' value={name} />
					<Label label='Opprettet' value={format(date, 'yyyy-MM-dd HH:mm:ss')} />
					<Label label='Artikkel nummer' value={article?.length ? article.join(', ') : '-'} />
				</div>
			</Box>
		</Modal>
	);
}
